<header class="pt-5">
  <div class="container-fluid">
    <div class="row">
        <div id="anim-container" class="mx-auto text-kl-white text-center">
            <div class="bg-pynt d-none d-sm-block"><img src="../../../../assets/images/forside_hero/pynt.svg" alt=""></div>
            <figure id="kal-laage">
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 600 458" style="enable-background:new 0 0 600 458;" xml:space="preserve">
         <style type="text/css">
             .st0{clip-path:url(#SVGID_00000004533738337767035570000004880575539779963568_);fill:#FFF5E0;}
             .st1{clip-path:url(#SVGID_00000004533738337767035570000004880575539779963568_);}
             .st2{fill:#FF292E;}
             .st3{clip-path:url(#SVGID_00000074432276682117379820000002049271627646711476_);fill:#FFF5E0;}
             .st4{clip-path:url(#SVGID_00000182489336862933829830000004534551643383438212_);fill:#FFF5E0;}
             .st5{clip-path:url(#SVGID_00000132789825341807819170000008299660294136982405_);fill:#FFF5E0;}
             .st6{clip-path:url(#SVGID_00000034792220529923968420000013920148709749733037_);fill:#FFF5E0;}
             .st7{clip-path:url(#SVGID_00000041991911428433255150000007006620532355686293_);fill:#FFF5E0;}
             .st8{clip-path:url(#SVGID_00000041978629284001971400000006949702709960461726_);fill:#FFF5E0;}
             .st9{clip-path:url(#SVGID_00000046323683535533162230000002803176588928590495_);fill:#FFF5E0;}
             .st10{clip-path:url(#SVGID_00000155829205312184287540000015760302122364931474_);fill:#FFF5E0;}
             .st11{clip-path:url(#SVGID_00000096765621950369948310000010523788787420754562_);fill:#FFF5E0;}
             .st12{clip-path:url(#SVGID_00000005989185882930948400000014204464114782586499_);fill:#FFF5E0;}
             .st13{clip-path:url(#SVGID_00000115498558141713886600000002720002205698625931_);fill:#FFF5E0;}
             .st14{clip-path:url(#SVGID_00000088821397263073546340000011383094475118581901_);fill:#FFF5E0;}
             .st15{clip-path:url(#SVGID_00000003808822263164213750000004413291925969456292_);fill:#FFF5E0;}
             .st16{clip-path:url(#SVGID_00000077294264264746037930000004262979826716814014_);fill:#FFF5E0;}
             .st17{clip-path:url(#SVGID_00000103246830240047428170000008126611623176109963_);fill:#FFF5E0;}
             .st18{clip-path:url(#SVGID_00000104674151140349129210000015955278969405181606_);fill:#FFF5E0;}
             .st19{clip-path:url(#SVGID_00000032617517518352522770000018045404634020784549_);fill:#FFF5E0;}
             .st20{clip-path:url(#SVGID_00000150080545924520489010000006762950110621227146_);fill:#FFF5E0;}
             .st21{clip-path:url(#SVGID_00000126302846017433066420000002642906008209936795_);fill:#FFF5E0;}
             .st22{clip-path:url(#SVGID_00000120557666818639791240000016979173993298949510_);fill:#FFF5E0;}
             .st23{clip-path:url(#SVGID_00000028300822672533808230000009965038828414231684_);fill:#FFF5E0;}
             .st24{clip-path:url(#SVGID_00000127745214098460574450000015467951718336844715_);fill:#FFF5E0;}
             .st25{clip-path:url(#SVGID_00000079466890426823210080000003164588279789896857_);}
             .st26{clip-path:url(#SVGID_00000004515434884137230900000002287667284340909744_);fill:#FFF5E0;}
             .st27{clip-path:url(#SVGID_00000004515434884137230900000002287667284340909744_);fill:#FF292E;}
         </style>
         <g>
             <defs>
                 <rect id="SVGID_1_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000031892058929683074540000017275849019431415701_">
                 <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000031892058929683074540000017275849019431415701_);fill:#FFF5E0;" d="M143.2,164.6
                 c-13.2-1.9-26-1.9-38.9,0c-1.9,13.3-1.9,26.2,0,39.2c13.2,1.9,26,1.9,38.9,0C145.1,190.5,145.1,177.5,143.2,164.6"/>
             <g style="clip-path:url(#SVGID_00000031892058929683074540000017275849019431415701_);">
                 <path class="st2" d="M117.6,175.5v18h-4.4v-12.6c-1.1,0.6-2.3,1.1-3.5,1.5v-4c1.9-0.7,3.7-1.6,5.2-2.9H117.6z"/>
                 <path class="st2" d="M120.3,184.5c0-4.7,2.1-9.4,7.3-9.4s7.3,4.7,7.3,9.4c0,4.6-2.2,9.4-7.3,9.4S120.3,189.1,120.3,184.5z
                      M130.2,184.5c0-3.3-1-5.1-2.7-5.1c-1.6,0-2.7,1.7-2.7,5.1c0,3.3,1,5.1,2.7,5.1C129.2,189.6,130.2,187.8,130.2,184.5z"/>
             </g>
             <path style="clip-path:url(#SVGID_00000031892058929683074540000017275849019431415701_);fill:#FFF5E0;" d="M58.3,304.3
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C60.2,331.2,60.2,317.8,58.3,304.3"/>
         </g>
         <g>
             <path class="st2" d="M32.3,328.8h5.6v4.5H25.8v-2.9l4.5-4.8c1.7-1.8,2.6-3.5,2.6-5c0-1.6-1-2.3-2.6-2.3c-1,0-2.6,0.4-3.8,1.1V315
                 c1.2-0.7,3.4-1.1,5-1.1c4.6,0,6.5,2.7,6.5,5.4c0,2.9-1.6,5.4-4,7.9L32.3,328.8z"/>
             <path class="st2" d="M48.4,314.3v19.1h-4.9V320c-1.3,0.6-2.6,1.1-4,1.6v-4.3c2.2-0.7,4.1-1.7,5.9-3.1H48.4z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000127733876298401383450000015467295393486235048_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000163070000878851289830000013910502885544571571_">
                 <use xlink:href="#SVGID_00000127733876298401383450000015467295393486235048_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000163070000878851289830000013910502885544571571_);fill:#FFF5E0;" d="M319.1,304.3
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C321,331.2,321,317.8,319.1,304.3"/>
         </g>
         <g>
             <path class="st2" d="M294.1,314.3v19.1h-4.9V320c-1.3,0.6-2.6,1.1-4,1.6v-4.3c2.2-0.7,4.1-1.7,5.9-3.1H294.1z"/>
             <path class="st2" d="M311.9,325.8v3.7h-2.3v3.9h-4.8v-3.9h-8.2c1.7-4.8,3.1-9.9,4.2-15.2h4.5c-0.8,4-1.8,7.9-2.9,11.5h2.4v-3.5h4.8
                 v3.5H311.9z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000000934636989082462390000001493401310568605602_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000001626825782035594360000002062485759659476364_">
                 <use xlink:href="#SVGID_00000000934636989082462390000001493401310568605602_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000001626825782035594360000002062485759659476364_);fill:#FFF5E0;" d="M492.9,304.3
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C494.9,331.2,494.9,317.8,492.9,304.3"/>
         </g>
         <g>
             <path class="st2" d="M476.3,314.3v19.1h-4.9V320c-1.3,0.6-2.6,1.1-4,1.6v-4.3c2.2-0.7,4.1-1.7,5.9-3.1H476.3z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000124860350054437742080000004419785416742921646_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000095327855755024574890000013184091337472224171_">
                 <use xlink:href="#SVGID_00000124860350054437742080000004419785416742921646_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000095327855755024574890000013184091337472224171_);fill:#FFF5E0;" d="M407.1,97.9
                 c-14.2-1.8-27.9-1.8-41.7,0c-2,12.9-2,25.4,0,37.9c14.2,1.8,27.9,1.8,41.7,0C409.1,122.9,409.1,110.4,407.1,97.9"/>
         </g>
         <g>
             <path class="st2" d="M383,105.8v19.1h-4.9v-13.3c-1.3,0.6-2.6,1.1-4,1.6v-4.3c2.2-0.7,4.1-1.7,5.9-3.1H383z"/>
             <path class="st2" d="M385.3,105.8h13c-3.3,7.6-5.5,14-6.7,19.1h-5.1c1.1-4,2.9-8.8,5.5-14.6h-6.7V105.8z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000033362076006494974380000007879362810777564855_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000156583247228194530590000010590011769867799471_">
                 <use xlink:href="#SVGID_00000033362076006494974380000007879362810777564855_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000156583247228194530590000010590011769867799471_);fill:#FFF5E0;" d="M232.6,97.5
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C234.6,124.4,234.6,110.9,232.6,97.5"/>
         </g>
         <g>
             <path class="st2" d="M219.7,116.2c0,5.4-2,10.7-9.2,10.7c-1.3,0-2.8-0.2-4.2-0.8v-4.3c1.6,0.7,2.8,0.9,3.8,0.9
                 c2.9,0,4.6-1.3,4.9-4.7c-1,1.6-2.5,2.3-4.4,2.3c-3.8,0-5.9-2.9-5.9-6.2c0-3.6,2.3-7,7.1-7C217,107,219.7,110.9,219.7,116.2z
                  M214.4,113.8c0-1.6-0.9-2.8-2.5-2.8c-1.6,0-2.5,1.1-2.5,2.8c0,1.6,0.9,2.8,2.5,2.8C213.4,116.6,214.4,115.6,214.4,113.8z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000079448795838982250820000001329510963705549987_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000095319045990260301170000000108252925286237095_">
                 <use xlink:href="#SVGID_00000079448795838982250820000001329510963705549987_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000095319045990260301170000000108252925286237095_);fill:#FFF5E0;" d="M145.2,235.5
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C147.2,262.4,147.2,248.9,145.2,235.5"/>
         </g>
         <g>
             <path class="st2" d="M121.3,245.4v19.1h-4.9v-13.3c-1.3,0.6-2.6,1.1-4,1.6v-4.3c2.2-0.7,4.1-1.7,5.9-3.1H121.3z"/>
             <path class="st2" d="M137,259.1c0,3.3-2.7,5.8-7.4,5.8c-2,0-3.7-0.3-5.1-0.9v-4.3c1.2,0.5,2.8,0.9,4.1,0.9c2,0,3.1-0.6,3.1-2.2
                 c0-1.8-1.7-2.3-4-2.3h-1.1v-3.2h0.9c2.7,0,3.7-0.7,3.7-2c0-1.1-1-1.7-2.5-1.7c-1.4,0-2.6,0.4-3.9,1v-4.1c1.2-0.6,2.9-1,4.9-1
                 c4.5,0,6.7,2.1,6.7,4.9c0,2.1-1.2,3.5-3.3,4.3C135.7,255,137,256.9,137,259.1z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000144304396823163222340000007671627241149811344_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000139289418019857547790000012525471555565349766_">
                 <use xlink:href="#SVGID_00000144304396823163222340000007671627241149811344_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000139289418019857547790000012525471555565349766_);fill:#FFF5E0;" d="M319.4,96.4
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C321.4,123.3,321.4,109.8,319.4,96.4"/>
         </g>
         <g>
             <path class="st2" d="M299.4,120.9h5.6v4.5h-12.1v-2.9l4.5-4.8c1.7-1.8,2.6-3.5,2.6-5c0-1.6-1-2.3-2.6-2.3c-1,0-2.6,0.4-3.8,1.1
                 v-4.4c1.2-0.7,3.4-1.1,5-1.1c4.6,0,6.5,2.7,6.5,5.4c0,2.9-1.6,5.4-4,7.9L299.4,120.9z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000110456687479857145500000016567914346443946668_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000119091864083678940400000000929990733417041571_">
                 <use xlink:href="#SVGID_00000110456687479857145500000016567914346443946668_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000119091864083678940400000000929990733417041571_);fill:#FFF5E0;" d="M319.1,235.5
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C321,262.4,321,248.9,319.1,235.5"/>
         </g>
         <g>
             <path class="st2" d="M290.1,260h5.6v4.5h-12.1v-2.9l4.5-4.8c1.7-1.8,2.6-3.5,2.6-5c0-1.6-1-2.3-2.6-2.3c-1,0-2.6,0.4-3.8,1.1v-4.4
                 c1.2-0.7,3.4-1.1,5-1.1c4.6,0,6.5,2.7,6.5,5.4c0,2.9-1.6,5.4-4,7.9L290.1,260z"/>
             <path class="st2" d="M297.4,255c0-4.9,2.4-9.9,8.2-9.9c5.8,0,8.2,5,8.2,9.9c0,4.9-2.4,9.9-8.2,9.9
                 C299.8,264.9,297.4,259.9,297.4,255z M308.6,255c0-3.5-1.1-5.4-3-5.4c-1.9,0-3,1.8-3,5.4s1.1,5.4,3,5.4
                 C307.5,260.4,308.6,258.5,308.6,255z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000134249777688032005970000011575662491542123136_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000130633586763576187260000004049093630709639864_">
                 <use xlink:href="#SVGID_00000134249777688032005970000011575662491542123136_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000130633586763576187260000004049093630709639864_);fill:#FFF5E0;" d="M406.1,27.5
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C408.1,54.4,408.1,40.9,406.1,27.5"/>
         </g>
         <g>
             <path class="st2" d="M382.2,37.4v19.1h-4.9V43.2c-1.3,0.6-2.6,1.1-4,1.6v-4.3c2.2-0.7,4.1-1.7,5.9-3.1H382.2z"/>
             <path class="st2" d="M398.1,50.3c0,4-2.9,6.6-7.5,6.6c-2.1,0-3.9-0.4-5.2-1v-4.3c1.3,0.6,2.7,0.9,4.4,0.9c2.1,0,3.2-0.8,3.2-2.4
                 c0-1.4-1-2.4-3.6-2.4c-1.1,0-2.3,0.1-3.6,0.5c0.3-3.6,0.3-7.2,0-10.9h11.1V42h-7c0.1,0.9,0,1.9,0,2.8c0.7-0.2,1.4-0.3,2.2-0.3
                 C395.5,44.5,398.1,46.6,398.1,50.3z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000059300688045250887950000014390885588424358588_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000018948536075956740020000001101003647203432114_">
                 <use xlink:href="#SVGID_00000059300688045250887950000014390885588424358588_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000018948536075956740020000001101003647203432114_);fill:#FFF5E0;" d="M492.9,235.5
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C494.9,262.4,494.9,248.9,492.9,235.5"/>
         </g>
         <g>
             <path class="st2" d="M464.7,260h5.6v4.5h-12.1v-2.9l4.5-4.8c1.7-1.8,2.6-3.5,2.6-5c0-1.6-1-2.3-2.6-2.3c-1,0-2.6,0.4-3.8,1.1v-4.4
                 c1.2-0.7,3.4-1.1,5-1.1c4.6,0,6.5,2.7,6.5,5.4c0,2.9-1.6,5.4-4,7.9L464.7,260z"/>
             <path class="st2" d="M486.8,256.9v3.7h-2.3v3.9h-4.8v-3.9h-8.2c1.7-4.8,3.1-9.9,4.2-15.2h4.5c-0.8,4-1.8,7.9-2.9,11.5h2.4v-3.5h4.8
                 v3.5H486.8z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000075135343161768881900000007856045285095938197_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000178924354252864844540000011199358945841939872_">
                 <use xlink:href="#SVGID_00000075135343161768881900000007856045285095938197_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000178924354252864844540000011199358945841939872_);fill:#FFF5E0;" d="M58.3,165.5
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C60.2,192.4,60.2,179,58.3,165.5"/>
         </g>
         <g>
             <path class="st2" d="M44.3,188.4c0,4-2.9,6.6-7.5,6.6c-2.1,0-3.9-0.4-5.2-1v-4.3c1.3,0.6,2.7,0.9,4.4,0.9c2.1,0,3.2-0.8,3.2-2.4
                 c0-1.4-1-2.4-3.6-2.4c-1.1,0-2.3,0.1-3.6,0.5c0.3-3.6,0.3-7.2,0-10.9h11.1v4.5h-7c0.1,0.9,0,1.9,0,2.8c0.7-0.2,1.4-0.3,2.2-0.3
                 C41.7,182.5,44.3,184.7,44.3,188.4z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000121984490314681571270000014461041170553799040_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000047762832851553293280000012552653555737838506_">
                 <use xlink:href="#SVGID_00000121984490314681571270000014461041170553799040_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000047762832851553293280000012552653555737838506_);fill:#FFF5E0;" d="M232.1,304.3
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C234.1,331.2,234.1,317.8,232.1,304.3"/>
         </g>
         <g>
             <path class="st2" d="M205.3,328.8h5.6v4.5h-12.1v-2.9l4.5-4.8c1.7-1.8,2.6-3.5,2.6-5c0-1.6-1-2.3-2.6-2.3c-1,0-2.6,0.4-3.8,1.1V315
                 c1.2-0.7,3.4-1.1,5-1.1c4.6,0,6.5,2.7,6.5,5.4c0,2.9-1.6,5.4-4,7.9L205.3,328.8z"/>
             <path class="st2" d="M218.9,328.8h5.6v4.5h-12.1v-2.9l4.5-4.8c1.7-1.8,2.6-3.5,2.6-5c0-1.6-1-2.3-2.6-2.3c-1,0-2.6,0.4-3.8,1.1V315
                 c1.2-0.7,3.4-1.1,5-1.1c4.6,0,6.5,2.7,6.5,5.4c0,2.9-1.6,5.4-4,7.9L218.9,328.8z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000071552770009520884640000013942100009111104165_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000069360712102874736170000014904180526917650855_">
                 <use xlink:href="#SVGID_00000071552770009520884640000013942100009111104165_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000069360712102874736170000014904180526917650855_);fill:#FFF5E0;" d="M319.1,27.5
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C321,54.4,321,40.9,319.1,27.5"/>
         </g>
         <g>
             <path class="st2" d="M305,51.1c0,3.3-2.7,5.8-7.4,5.8c-2,0-3.7-0.3-5.1-0.9v-4.3c1.2,0.5,2.8,0.9,4.1,0.9c2,0,3.1-0.6,3.1-2.2
                 c0-1.8-1.7-2.3-4-2.3h-1.1v-3.2h0.9c2.7,0,3.7-0.7,3.7-2c0-1.1-1-1.7-2.5-1.7c-1.4,0-2.6,0.4-3.9,1v-4.1c1.2-0.6,2.9-1,4.9-1
                 c4.5,0,6.7,2.1,6.7,4.9c0,2.1-1.2,3.5-3.3,4.3C303.7,47,305,48.9,305,51.1z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000072240060977883020750000004678333909337007542_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000000927817316346875310000012513382625411748247_">
                 <use xlink:href="#SVGID_00000072240060977883020750000004678333909337007542_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000000927817316346875310000012513382625411748247_);fill:#FFF5E0;" d="M492.9,27.5
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C494.9,54.4,494.9,40.9,492.9,27.5"/>
         </g>
         <g>
             <path class="st2" d="M480.1,49.9c0,3.6-2.3,7-7.1,7c-5.2,0-7.9-3.9-7.9-9.2c0-5.3,2-10.6,9.2-10.6c1.3,0,2.8,0.2,4.2,0.8v4.3
                 c-1.6-0.7-2.8-0.9-3.8-0.9c-2.9,0-4.6,1.3-4.9,4.7c1-1.6,2.5-2.3,4.4-2.3C478,43.7,480.1,46.6,480.1,49.9z M475.4,50.1
                 c0-1.6-0.9-2.7-2.5-2.7c-1.5,0-2.5,1-2.5,2.7c0,1.6,0.9,2.8,2.5,2.8C474.5,52.9,475.4,51.7,475.4,50.1z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000153671748423421828240000008335686948299138726_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000114055518392357011730000017120080565018058881_">
                 <use xlink:href="#SVGID_00000153671748423421828240000008335686948299138726_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000114055518392357011730000017120080565018058881_);fill:#FFF5E0;" d="M581.1,167.6
                 c-14.3-1.9-28.1-1.9-42,0c-2,13-2,25.7,0,38.4c14.3,1.9,28.1,1.9,42,0C583.1,192.9,583.1,180.3,581.1,167.6"/>
         </g>
         <g>
             <path class="st2" d="M555.2,175.5v19.1h-4.9v-13.3c-1.3,0.6-2.6,1.1-4,1.6v-4.3c2.2-0.7,4.1-1.7,5.9-3.1H555.2z"/>
             <path class="st2" d="M572.8,184.3c0,5.4-2,10.7-9.2,10.7c-1.3,0-2.8-0.2-4.2-0.8v-4.3c1.6,0.7,2.8,0.9,3.8,0.9
                 c2.9,0,4.6-1.3,4.9-4.7c-1,1.6-2.5,2.3-4.4,2.3c-3.8,0-5.9-2.9-5.9-6.2c0-3.6,2.3-7,7.1-7C570.1,175.1,572.8,179,572.8,184.3z
                  M567.5,181.9c0-1.6-0.9-2.8-2.5-2.8c-1.6,0-2.5,1.1-2.5,2.8c0,1.6,0.9,2.8,2.5,2.8C566.5,184.6,567.5,183.6,567.5,181.9z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000016788564607972947230000001116559871647395480_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000041288452072052723450000001661456922779340178_">
                 <use xlink:href="#SVGID_00000016788564607972947230000001116559871647395480_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000041288452072052723450000001661456922779340178_);fill:#FFF5E0;" d="M145.2,27.5
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C147.2,54.4,147.2,40.9,145.2,27.5"/>
         </g>
         <g>
             <path class="st2" d="M132.2,49v3.7h-2.3v3.9h-4.8v-3.9h-8.2c1.7-4.8,3.1-9.9,4.2-15.2h4.5c-0.8,4-1.8,7.9-2.9,11.5h2.4v-3.5h4.8V49
                 H132.2z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000121269450018914906390000011922648582877611178_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000142894313115510967070000016058049151837908132_">
                 <use xlink:href="#SVGID_00000121269450018914906390000011922648582877611178_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000142894313115510967070000016058049151837908132_);fill:#FFF5E0;" d="M406.1,165.3
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C408.1,192.2,408.1,178.8,406.1,165.3"/>
         </g>
         <g>
             <path class="st2" d="M381.3,175.3v19.1h-4.9V181c-1.3,0.6-2.6,1.1-4,1.6v-4.3c2.2-0.7,4.1-1.7,5.9-3.1H381.3z"/>
             <path class="st2" d="M399.2,187.8c0,3.6-2.3,7-7.1,7c-5.2,0-7.9-3.9-7.9-9.2c0-5.3,2-10.6,9.2-10.6c1.3,0,2.8,0.2,4.2,0.8v4.3
                 c-1.6-0.7-2.8-0.9-3.8-0.9c-2.9,0-4.6,1.3-4.9,4.7c1-1.6,2.5-2.3,4.4-2.3C397.1,181.5,399.2,184.4,399.2,187.8z M394.5,187.9
                 c0-1.6-0.9-2.7-2.5-2.7c-1.5,0-2.5,1-2.5,2.7c0,1.6,0.9,2.8,2.5,2.8C393.6,190.7,394.5,189.6,394.5,187.9z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000096029768588619048360000011965096912500845746_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000076584258970528931410000012509255452907233203_">
                 <use xlink:href="#SVGID_00000096029768588619048360000011965096912500845746_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000076584258970528931410000012509255452907233203_);fill:#FFF5E0;" d="M492.9,165.5
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C494.9,192.4,494.9,179,492.9,165.5"/>
         </g>
         <g>
             <path class="st2" d="M465.6,190h5.6v4.5h-12.1v-2.9l4.5-4.8c1.7-1.8,2.6-3.5,2.6-5c0-1.6-1-2.3-2.6-2.3c-1,0-2.6,0.4-3.8,1.1v-4.4
                 c1.2-0.7,3.4-1.1,5-1.1c4.6,0,6.5,2.7,6.5,5.4c0,2.9-1.6,5.4-4,7.9L465.6,190z"/>
             <path class="st2" d="M485.6,189.1c0,3.3-2.7,5.8-7.4,5.8c-2,0-3.7-0.3-5.1-0.9v-4.3c1.2,0.5,2.8,0.9,4.1,0.9c2,0,3.1-0.6,3.1-2.2
                 c0-1.8-1.7-2.3-4-2.3h-1.1v-3.2h0.9c2.7,0,3.7-0.7,3.7-2c0-1.1-1-1.7-2.5-1.7c-1.4,0-2.6,0.4-3.9,1v-4.1c1.2-0.6,2.9-1,4.9-1
                 c4.5,0,6.7,2.1,6.7,4.9c0,2.1-1.2,3.5-3.3,4.3C484.4,185.1,485.6,186.9,485.6,189.1z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000054972400795898069950000013299796576003712899_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000153673791949716407530000005230261375483327925_">
                 <use xlink:href="#SVGID_00000054972400795898069950000013299796576003712899_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000153673791949716407530000005230261375483327925_);fill:#FFF5E0;" d="M579.8,96.8
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C581.8,123.7,581.8,110.2,579.8,96.8"/>
         </g>
         <g>
             <path class="st2" d="M557.4,106.7v19.1h-4.9v-13.3c-1.3,0.6-2.6,1.1-4,1.6v-4.3c2.2-0.7,4.1-1.7,5.9-3.1H557.4z"/>
             <path class="st2" d="M569.1,106.7v19.1h-4.9v-13.3c-1.3,0.6-2.6,1.1-4,1.6v-4.3c2.2-0.7,4.1-1.7,5.9-3.1H569.1z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000111157579940289004600000008307235436075156667_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000182516512991653597350000004765670105017585063_">
                 <use xlink:href="#SVGID_00000111157579940289004600000008307235436075156667_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000182516512991653597350000004765670105017585063_);fill:#FFF5E0;" d="M58.3,96.8
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C60.2,123.7,60.2,110.2,58.3,96.8"/>
         </g>
         <g>
             <path class="st2" d="M34.8,106.7v19.1h-4.9v-13.3c-1.3,0.6-2.6,1.1-4,1.6v-4.3c2.2-0.7,4.1-1.7,5.9-3.1H34.8z"/>
             <path class="st2" d="M44.1,121.3h5.6v4.5H37.5v-2.9l4.5-4.8c1.7-1.8,2.6-3.5,2.6-5c0-1.6-1-2.3-2.6-2.3c-1,0-2.6,0.4-3.8,1.1v-4.4
                 c1.2-0.7,3.4-1.1,5-1.1c4.6,0,6.5,2.7,6.5,5.4c0,2.9-1.6,5.4-4,7.9L44.1,121.3z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000092445602096161665830000008309957159944664464_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000067222806416110696270000006473197670554654368_">
                 <use xlink:href="#SVGID_00000092445602096161665830000008309957159944664464_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000067222806416110696270000006473197670554654368_);fill:#FFF5E0;" d="M232.1,165.5
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C234.1,192.4,234.1,179,232.1,165.5"/>
         </g>
         <g>
             <path class="st2" d="M219.1,189.2c0,2.8-1.9,5.7-7.4,5.7c-5.5,0-7.3-2.9-7.3-5.7c0-1.8,0.9-3.6,3.1-4.5c-1.7-1-2.4-2.6-2.4-4.2
                 c0-2.6,1.6-5.4,6.7-5.4s6.7,2.8,6.7,5.4c0,1.6-0.7,3.2-2.5,4.2C218.2,185.7,219.1,187.4,219.1,189.2z M214.4,188.5
                 c0-1.3-0.8-2.5-2.6-2.5c-1.8,0-2.6,1.1-2.6,2.5c0,1.3,0.8,2.4,2.6,2.4C213.6,190.9,214.4,189.7,214.4,188.5z M209.5,180.9
                 c0,1.1,0.8,2.2,2.3,2.2c1.5,0,2.3-1,2.3-2.2c0-1.2-0.7-2.2-2.3-2.2C210.3,178.7,209.5,179.7,209.5,180.9z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000056410281460961400160000002381801820115610813_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000168839893324537668060000008646013719478026912_">
                 <use xlink:href="#SVGID_00000056410281460961400160000002381801820115610813_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000168839893324537668060000008646013719478026912_);fill:#FFF5E0;" d="M406.1,304.3
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C408.1,331.2,408.1,317.8,406.1,304.3"/>
         </g>
         <g>
             <path class="st2" d="M381.6,314.3v19.1h-4.9V320c-1.3,0.6-2.6,1.1-4,1.6v-4.3c2.2-0.7,4.1-1.7,5.9-3.1H381.6z"/>
             <path class="st2" d="M399,328c0,2.8-1.9,5.7-7.4,5.7s-7.3-2.9-7.3-5.7c0-1.8,0.9-3.6,3.1-4.5c-1.7-1-2.4-2.6-2.4-4.2
                 c0-2.6,1.6-5.4,6.7-5.4c5.1,0,6.7,2.8,6.7,5.4c0,1.6-0.7,3.2-2.5,4.2C398.1,324.5,399,326.2,399,328z M394.2,327.3
                 c0-1.3-0.8-2.5-2.6-2.5c-1.8,0-2.6,1.1-2.6,2.5c0,1.3,0.8,2.4,2.6,2.4C393.4,329.7,394.2,328.5,394.2,327.3z M389.4,319.7
                 c0,1.1,0.8,2.2,2.3,2.2c1.5,0,2.3-1,2.3-2.2c0-1.2-0.7-2.2-2.3-2.2C390.1,317.5,389.4,318.5,389.4,319.7z"/>
         </g>
         <g>
             <defs>
                 <rect id="SVGID_00000173869823987565992750000010732007429587014058_" width="600" height="458"/>
             </defs>
             <clipPath id="SVGID_00000138575130721754724530000001370941645999976840_">
                 <use xlink:href="#SVGID_00000173869823987565992750000010732007429587014058_"  style="overflow:visible;"/>
             </clipPath>
             <path style="clip-path:url(#SVGID_00000138575130721754724530000001370941645999976840_);fill:#FFF5E0;" d="M579.8,235.5
                 c-13.9-2-27.3-2-40.8,0c-2,13.9-2,27.3,0,40.8c13.9,2,27.3,2,40.8,0C581.8,262.4,581.8,248.9,579.8,235.5"/>
         </g>
         <g>
             <path class="st2" d="M553.2,245.4h13c-3.3,7.6-5.5,14-6.7,19.1h-5.1c1.1-4,2.9-8.8,5.5-14.6h-6.7V245.4z"/>
         </g>
         <g>
             <defs>
                 <polygon id="SVGID_00000050655761692934588780000015664206459303498393_" points="102.7,164.2 102.7,207.2 123.5,210.1 
                     123.5,161.3 		"/>
             </defs>
             <clipPath id="SVGID_00000047775760768262670360000006801278676994160513_">
                 <use xlink:href="#SVGID_00000050655761692934588780000015664206459303498393_"  style="overflow:visible;"/>
             </clipPath>
             <g style="clip-path:url(#SVGID_00000047775760768262670360000006801278676994160513_);">
                 <defs>
                     <rect id="SVGID_00000153682662024266318600000005107142706727800451_" x="-2188.1" y="196.5" width="2225.8" height="5079.4"/>
                 </defs>
                 <clipPath id="SVGID_00000005265128716303918120000012190792734292171432_">
                     <use xlink:href="#SVGID_00000153682662024266318600000005107142706727800451_"  style="overflow:visible;"/>
                 </clipPath>
                 <path style="clip-path:url(#SVGID_00000005265128716303918120000012190792734292171432_);fill:#FFF5E0;" d="M25.5,198.4
                     c-0.9,0.1-1.8,0.3-2.7,0.5c-0.9,0.2-1.7,0.4-2.6,0.7c-0.9,0.3-1.7,0.5-2.5,0.9c-0.8,0.3-1.6,0.7-2.5,1.1
                     c-0.2,3.9-0.4,7.7-0.5,11.6c-0.1,3.8-0.2,7.6-0.2,11.4c0,3.8,0.1,7.5,0.2,11.3c0.1,3.8,0.3,7.5,0.5,11.3c0.8,0.4,1.7,0.7,2.5,1.1
                     c0.9,0.3,1.7,0.6,2.6,0.9c0.9,0.3,1.7,0.5,2.6,0.7c0.9,0.2,1.8,0.4,2.7,0.5c0.9,0.1,1.8,0.2,2.8,0.3c0.9,0.1,1.9,0.1,2.8,0.1
                     c1,0,1.9-0.1,2.9-0.2c1-0.1,2-0.2,3-0.4c0.3-4.3,0.5-8.6,0.7-12.9c0.2-4.3,0.2-8.6,0.2-12.9c0-4.3-0.1-8.5-0.2-12.8
                     c-0.2-4.2-0.4-8.5-0.7-12.7c-1-0.2-2.1-0.3-3.1-0.4c-1-0.1-2-0.1-3-0.2c-1,0-1.9,0-2.9,0.1C27.3,198.2,26.4,198.3,25.5,198.4
                      M28.7,235.1c-0.8,0-1.5-0.5-2-1.1c-0.6-0.7-1-1.6-1.4-2.7c-0.4-1.1-0.6-2.4-0.8-3.8c-0.2-1.4-0.2-2.8-0.2-4.3
                     c0-1.4,0.1-2.9,0.2-4.3c0.2-1.4,0.4-2.7,0.8-3.8c0.4-1.1,0.8-2.1,1.4-2.8c0.6-0.7,1.2-1.1,2-1.2c0.8-0.1,1.5,0.3,2.1,0.9
                     c0.6,0.6,1.1,1.6,1.5,2.7c0.4,1.1,0.7,2.5,0.9,3.9c0.2,1.4,0.3,2.9,0.3,4.5c0,1.5-0.1,3-0.3,4.5c-0.2,1.4-0.5,2.8-0.9,3.9
                     c-0.4,1.1-0.9,2.1-1.5,2.7C30.2,234.9,29.5,235.2,28.7,235.1 M18.2,220.8v-4.9c0.3-0.2,0.5-0.5,0.8-0.7c0.3-0.3,0.5-0.5,0.8-0.9
                     c0.2-0.3,0.5-0.6,0.7-1c0.2-0.4,0.5-0.7,0.7-1.2l1.5-0.1v22.2l-2.5-0.1v-15.3c-0.2,0.2-0.3,0.3-0.5,0.5c-0.2,0.2-0.3,0.3-0.5,0.5
                     c-0.2,0.2-0.3,0.3-0.5,0.5C18.5,220.5,18.4,220.7,18.2,220.8 M28.7,216.7c-0.3,0-0.5,0.2-0.7,0.4c-0.2,0.3-0.4,0.7-0.5,1.2
                     c-0.1,0.5-0.3,1.2-0.3,2c-0.1,0.8-0.1,1.7-0.1,2.8c0,1.1,0,2,0.1,2.8c0.1,0.8,0.2,1.5,0.3,2s0.3,1,0.5,1.2
                     c0.2,0.3,0.4,0.4,0.7,0.4c0.3,0,0.5-0.1,0.7-0.4c0.2-0.3,0.4-0.7,0.5-1.2c0.1-0.5,0.3-1.2,0.3-2c0.1-0.8,0.1-1.8,0.1-2.8
                     c0-1.1,0-2-0.1-2.8c-0.1-0.8-0.2-1.5-0.3-2c-0.1-0.5-0.3-0.9-0.5-1.2C29.2,216.9,29,216.7,28.7,216.7"/>
                 <path style="clip-path:url(#SVGID_00000005265128716303918120000012190792734292171432_);fill:#FF292E;" d="M22.7,212.1l-1.5,0.1
                     c-0.2,0.4-0.5,0.8-0.7,1.2c-0.2,0.4-0.5,0.7-0.7,1c-0.2,0.3-0.5,0.6-0.8,0.9c-0.3,0.3-0.5,0.5-0.8,0.7v4.9
                     c0.2-0.1,0.3-0.3,0.5-0.4s0.3-0.3,0.5-0.5c0.2-0.2,0.3-0.3,0.5-0.5c0.2-0.2,0.3-0.3,0.5-0.5v15.3l2.5,0.1V212.1z"/>
                 <path style="clip-path:url(#SVGID_00000005265128716303918120000012190792734292171432_);fill:#FF292E;" d="M28.7,211.3
                     c-0.8,0.1-1.5,0.5-2,1.2c-0.6,0.7-1,1.6-1.4,2.8c-0.4,1.1-0.6,2.4-0.8,3.8c-0.2,1.4-0.2,2.8-0.2,4.3c0,1.4,0.1,2.9,0.2,4.3
                     c0.2,1.4,0.4,2.7,0.8,3.8c0.4,1.1,0.8,2.1,1.4,2.7c0.6,0.7,1.2,1.1,2,1.1c0.8,0,1.5-0.3,2.1-0.9c0.6-0.6,1.1-1.6,1.5-2.7
                     c0.4-1.1,0.7-2.5,0.9-3.9c0.2-1.4,0.3-2.9,0.3-4.5c0-1.5-0.1-3-0.3-4.5c-0.2-1.4-0.5-2.7-0.9-3.9c-0.4-1.1-0.9-2-1.5-2.7
                     C30.2,211.5,29.5,211.2,28.7,211.3 M28.7,229.7c-0.3,0-0.5-0.2-0.7-0.4c-0.2-0.3-0.4-0.7-0.5-1.2s-0.3-1.2-0.3-2
                     c-0.1-0.8-0.1-1.7-0.1-2.8c0-1.1,0-2,0.1-2.8c0.1-0.8,0.2-1.5,0.3-2c0.1-0.5,0.3-1,0.5-1.2c0.2-0.3,0.4-0.4,0.7-0.4
                     c0.3,0,0.5,0.1,0.7,0.4c0.2,0.3,0.4,0.7,0.5,1.2c0.1,0.5,0.3,1.2,0.3,2c0.1,0.8,0.1,1.8,0.1,2.8c0,1.1,0,2-0.1,2.8
                     c-0.1,0.8-0.2,1.5-0.3,2c-0.1,0.5-0.3,0.9-0.5,1.2C29.2,229.5,29,229.7,28.7,229.7"/>
             </g>
         </g>
         </svg>
          </figure>
         
            <div id="kal-pynt"><img src="../../../../assets/images/forside_hero/kal-pynt.svg" alt=""></div>
            <h1 id="splitit" class="kl-display-1 txt1">
                JULEKALENDEREN
            </h1>
            <h3 class="sub">Tilmeld dig vores nyhedsbrev og deltag i konkurrencen med en samlet præmiepulje på over 100.000 kr.</h3> 
            
            <a (click)="showPage()" class="cta cta--primary cta--large mt-3">Deltag her</a>
           
            <div class="compliance">
                <div class="compliance-text">
                    <p>Giv samtykke ml. d. 17.11-24.12.22 til markedsføring pr. mail, og deltag i lodtrækningen om tre daglige præmier ved at svare korrekt på dagens spørgsmål fra d. 1.-24.12.22. For hvert afgivet svar får du et lod til lodtrækningen om hovedpræmien på 25.000 kr. Samlet præmiepulje: 116.400 kr. Vindere offentliggøres på Klasselotteriets hjemmeside. Du kan deltage én gang pr. dag. Regler og vilkår gælder. Læs mere på julekalender.klasselotteriet.dk.</p>
                </div>
                <!--
                <div class="compliance-icons">
                    <div class="compliance-icons-item">
                        <a (click)="navigateToSubPage('/om-klasselotteriet/ansvarligt-spil')">| Spil ansvarligt |</a>
                    </div>
                    <div class="compliance-icons-item">
                        <img src="assets/images/spm/18-plus-bold.png" class="age" alt="18plus">
                    </div>
                    <div class="compliance-icons-item">
                        <img src="assets/images/spm/spillemyndigheden.svg" class="auth" alt="Spillemyndigheden">
                    </div>
                    <div class="compliance-icons-item">
                        <img src="assets/images/spm/stop-logo.svg" class="stop" alt="Stop-spillet">
                    </div>
                </div>
                -->
            </div>
        </div> 
    </div> <!--row-->
    </div> <!--container-->
</header>
